export default "__VITE_ASSET__769d6720__"